<template>
  <div>
    <van-nav-bar style="background: #ffffff;color:#323233;font-weight: bold"
      fixed
      title="赠品入库"
      left-arrow
      @click-left="onClickLeft"
    />

    <div id="aaa"></div>

    <van-cell-group title="影像中心" :border="false">
      <van-cell :title="currentAgent.name" is-link to="pwalist" style="border-bottom:0.1px solid 	#F5F5F5"/>
    </van-cell-group>
  

    <van-cell-group title="备注" :border="false">
      <van-cell style="border-bottom:0.1px solid 	#F5F5F5">
        <van-field
          v-model="message"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          placeholder="供应商赠送"
          show-word-limit
          />
      </van-cell>
    </van-cell-group>
    
    <van-cell-group title="入库仓库" :border="false" class="">
      <van-cell style="border-bottom:0.1px solid 	#F5F5F5" class="choiceWarhouse" >
        <van-row type="flex">
          <van-col span="24">
            <van-tag 
              v-for="(warehousename,warehouseindex) in currentAgent.warehouse" 
              :key="warehouseindex" 
              round 
              :class="{selected:warehousename.id==warehouseMainDefaultSel}" 
              @click="mainSelect(warehousename.id)">{{warehousename.warehouse_name}}
            </van-tag>
          </van-col>      
        </van-row>
      </van-cell>
    </van-cell-group>

    <van-cell-group title="入库明细" :border="false">
      <van-cell class="box">
        <van-swipe-cell v-for="(item,index) in giftDetail" :key="index"
                        :class="{selecteddetail:defaultDetail==index}" @click="toggleDetail(index)">
        <van-cell  class="detailcell">
          <van-row class="ha" type="flex" justify="space-between">
            <van-col span="21">{{item.modelname}}</van-col>
            <van-col span="3"><van-icon name="search" @click="toHclist(index)" size="20px"/></van-col>

          </van-row>
          
          <van-row type="flex" justify="space-between">
            <van-col span="24">入库数量:<input type="text" style="width:60%;border:none" v-model="item.quantity" @input="notice(item.quantity)" /></van-col>
            </van-row>
          <van-row type="flex">
            <van-col span="6"><span style="color:#969799">入库仓库:</span></van-col>
              <van-col>
                <!-- <van-tag>{{item.shot}}</van-tag> -->
                <van-tag  plain type="danger" size="large" color="#838683" text-color="#838683" v-for="(warehousenam,warehouseind) in currentAgent.warehouse"
                  :key="warehouseind" 
                  round 
                  :class="{selected:warehousenam.id==item.warehouseId}" 
                  @click="toggleDetSel(warehousenam.id,index)">{{warehousenam.warehouse_name}}
                </van-tag>
             </van-col>

          </van-row>
        </van-cell>
          <van-button style="height: 100%;"
                      slot="right"
                      square
                      text="删除"
                      type="danger"
                      class="delete-button"
                      @click="del(index)"
          />

        </van-swipe-cell>
      </van-cell>
      <van-cell>
        <van-icon name="add-o" color="#07c160"  size="40" @click="add"  style="float:right"/>
      </van-cell>
    </van-cell-group>
    <van-cell-group>
      <van-cell>
        <van-button type="info" style="font-size: 0.47333rem;background: #30cca8;border-radius: 50px;border: 0.02667rem solid #30cca8;font-weight:bold" @click="qr">提交入库</van-button>
      </van-cell>
    </van-cell-group>
    <!--<div id="add">-->
      <!--<van-image round width="0.8rem" height="0.8rem" src="/img/add.png" @click="add"/>-->
    <!--</div> -->
    <div v-show='bottom_tip' style="font-size:10px;text-align:center;padding:10px 10px"> ©2020 一脉阳光集团信息中心</div>
  </div>

</template>

<script>
import { SwipeCell,NavBar  , Tag , DropdownMenu, DropdownItem ,Col, Row ,Panel,Divider,Button,Dialog, Icon,Image,Toast } from 'vant';
import {mapState,mapMutations} from 'vuex';
export default {
  components:{
    [NavBar.name]:NavBar,
    [Tag.name]:Tag,
    [Toast.name]:Toast,
    [DropdownMenu.name]:DropdownMenu,
    [DropdownItem.name]:DropdownItem,
    [Col.name]:Col,
    [Icon.name]:Icon,
    [Image.name]:Image,
    [Button.name]:Button,
    [Dialog.Component.name]: Dialog.Component,
    [Panel.name]:Panel,
    [Divider.name]:Divider,
    [Row.name]:Row,
      [SwipeCell.name]:SwipeCell
  },
  data(){
    return{
      message:"",
        bottom_tip:true,
      defaultDetail:0,
      //当前选中的影像中心
      currentAgent:'',
      warehouseMainDefaultSel:-1,
    }
  },
  methods: {
    ...mapMutations(['changePermissionAgent','changeDefaultAgentIndex','changeGiftDetail']),
    onClickLeft() {
      this.$router.push("/index")
    },
    toHclist(index) {
      this.$router.push({
        path:"/consumables",
        query:{
          from:'gift',
          index:index,
          message:this.message
        }
      })
    },
    mainSelect(index) {
      this.warehouseMainDefaultSel=index;
      if (this.giftDetail[0]) {
        let obj = {
          operator:'changeAllWarehouseSelected',
          warehouseId:index
        }
        this.changeGiftDetail(obj);
      }
      
    },
    toggleDetSel(index,ind) {
      //window.console.log(index,ind);
      let obj = {
        index:ind,
        operator:'changeItemWarehouseSelected',
        warehouseId:index
      };
      this.changeGiftDetail(obj);
    },
    getCurrentDate(format) {
      let now = new Date();
      let year = now.getFullYear(); //得到年份
      let month = now.getMonth();//得到月份
      let date = now.getDate();//得到日期
      let hour = now.getHours();//得到小时
      let minu = now.getMinutes();//得到分钟
      let sec = now.getSeconds();//得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      let time = "";
      //精确到天
      if(format==1){
        time = year + "-" + month + "-" + date;
      }
      //精确到分
      else if(format==2){
        time = year + "-" + month + "-" + date+ " " + hour + ":" + minu + ":" + sec;
      }
      return time;
    },
    parseSubmitData(obj) {
      let newarr = [];
      let message= '';
      for(let i=0;i<obj.length;i++) {
        if (!obj[i].modelname) {
          let num = i + 1;
          message = message + "第" + num + "条明细,未选择耗材！\n";
        }
        if (obj[i].warehouseId == -1) {
          let num = i + 1;
          message = message + "第" + num + "条明细,未选择仓库！\n";
        }
        if (obj[i].quantity.match(/\D/g)) {
          let num = i + 1;
          message = message + "第" + num + "条明细,入库数量有非数字字符或空格\n";
        }
        if (!obj[i].quantity || obj[i].quantity==0) {
          let num = i + 1;
          message = message + "第" + num + "条明细,入库数量为空或为0\n";
        }
        let newobj = {
          warehouseId:obj[i].warehouseId,
          purchaseOrderNum:0,
          purchaseOrderDetailId:0,
          branduuid:obj[i].branduuid,
          modeluuid:obj[i].modeluuid,
          unit:obj[i].unit,
          unitcost:obj[i].unitcost,
          quantity:obj[i].quantity
        }
        newarr.push(newobj);
      }
      return {
        message:message,
        data:newarr
      }
    },
    qr() {
      Dialog.confirm({ 
        message: '确认提交出库'
      }).then(() => {
        //window.console.log(this.getCurrentDate(2));
        let that = this;
        if(!this.message) {
            Toast('请输入备注信息');
          return;
        }
        if(!this.giftDetail[0]) {
            Toast('明细不能为空');
          return;
        }
        let result = this.parseSubmitData(this.giftDetail);
        // window.console.log(result);
        if(result.message) {
            Toast(result.message);
          return;
        } else {
          let data = {
            remark:this.message,
            creater:localStorage.getItem("workcode"),
            projectErpCode:this.currentAgent.erp_code,
            detail:result.data,
            voucherTime:this.getCurrentDate(2)
          }
          window.console.log(data);
          Toast.loading({
              message: '加载中...',
              forbidClick: true
          });

          this.$http({
            method:'post',
            url:'/mobile/giftStores',
            data
          }).then(function (response) {
            Toast.success('出库成功');
            window.console.log(response);
            that.$router.push("index")
          })
          
          
          
        }
        
        //window.console.log(this.giftDetail);
      }).catch(() => {
        // on cancel
      });
    },
    del(index){
      //this.changeOutStockDetail('del',index);
      let obj = {
        index,
        operator:'del'
      };
      this.changeGiftDetail(obj);
    },
    add(){
      //window.console.log(111);
      let obj = {
        operator:'add',
        warehouseId:this.warehouseMainDefaultSel
      };
      this.changeGiftDetail(obj);
    },
    toggleDetail(index) {
      this.defaultDetail = index;
    },
    notice(val) {

      if(val.match(/\D/g))   
      { 
        Toast("请勿输入非数字字符或者空格");
      }
    }
    
  },
  computed:{
    ...mapState(['permissionAgent','defaultAgentIndex','giftDetail']),
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == 'consumables') {
      next(vm => {
        if (vm.$route.params.modelname!=null) {
          let info = {
            operator :'update',
            index:vm.$route.params.index,
            modelname:vm.$route.params.modelname,
            branduuid:vm.$route.params.branduuid,
            modeluuid:vm.$route.params.modeluuid,
            unit:vm.$route.params.unit,
            unitcost:vm.$route.params.unitcost,
          }
          vm.defaultDetail = vm.$route.params.index;
          vm.message = vm.$route.params.message;
          vm.changeGiftDetail(info);
        }
        
        
      })
    } else {
      next(vm => {
        let clearall = {
          operator:'clearall'
        }
        vm.changeGiftDetail(clearall);
      })
    }
    
  },
  created() {
    if (this.permissionAgent) {
      let _this = this;
      this.currentAgent = this.permissionAgent.find(function(item) {
        // window.console.log(state.defaultAgentIndex);
        return item.id == _this.defaultAgentIndex;
      });
    } else {
      let _this = this;
      this.$http.post('/mobile/rimsAgentList',{
        username:localStorage.getItem('usermobile')
      }).then(function (response) {
        _this.changePermissionAgent(response.rimsAgent);
        _this.changeDefaultAgentIndex(response.rimsAgent[0].id);
        _this.currentAgent = _this.permissionAgent.find(function(item) {
        // window.console.log(state.defaultAgentIndex);
          return item.id == _this.defaultAgentIndex;
        });
      })
      
    }
  }
}
</script>
<style scoped lang="less">

.van-nav-bar{
  background: #456;
  color:white;
}
.van-nav-bar__title{
  font-weight: 800;
  color:#323233
}
.van-nav-bar .van-icon{
  color:#323233
}

.ha {
  border-bottom: 0.2px solid 	#DCDCDC	
}
.haha .van-cell{
  line-height: 1.2rem!important;
  border: 1px solid #dadae4;
  margin-bottom: 10px;
}
.ha {
  border-bottom: 0.2px solid 	#DCDCDC;
  font-weight: bold;
}
.haha .selecteddetail{
  /*background: #F4A460;*/
  background:#fafafa;
  border: 1px solid #dadae4;
}
.van-tag{
  margin-left:2%
}
.selected{
  background-color: #e2f3e2 !important;
  color:#32ca72!important
}
.box{
  background-color: #fff;
}
.box .selecteddetail{
  /*background-color: #e2f3e2 !important;*/
  /*color:#32ca72!important*/
}
.van-tag{
  margin-left:2%
}
.van-button {
        width:100%;
}
#aaa{
  width:100vw;
  height:46px;
}
#add{
  position: fixed;
  top:375px;
  right:0;
}
/*.selected{*/
  /*background-color: #e2f3e2 !important;*/
  /*color:#32ca72!important*/
/*}*/
.van-cell-group__title{
  color:#323233!important;
  font-weight: bold;
  font-size: 0.38rem;
  background-color: #f7f8fa;
}
.van-cell{
  color:#969799!important;
}

.van-tag--default {
  background-color: #f7f8fa;
}
.choiceWarhouse .van-tag{
  padding: .6em 1.5em!important;
  /*font-weight: bold;*/
  font-size: 0.40rem;
  margin: .2em;
  color:#323233;
  border-radius:10px;
}
.van-cell-group__title{
  color:#323233!important;
  font-weight: bold;
  font-size: 0.38rem;
  background-color: #f7f8fa;
}
.detailcell{
  line-height: 1.2rem!important;
  border: 1px solid #dadae4;
  margin-bottom: 10px;
  background: #f7f8fa;
}
.van-tag--danger.van-tag--plain{
  color: rgb(131, 134, 131);
}

</style>